/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum EntityType {
  Compact,
  Project,
  Company,
}
